import React from 'react';
import { Link } from "react-router-dom";
import ConcessionLocationController from './ConcessionLocationController.js';
import Spinner from "../../components/atoms/Spinner.js";
import GameSelector from '../Retail/components/GameSelector.js';
import ConcessionHeaderNav from './components/ConcessionHeaderNav.js';
import ConcessionLocationLiveView from './ConcessionLocationLiveView.js';
import ConcessionLocationHistoricalView from './ConcessionLocationHistoricalView.js';
import ConcessionOverview from './ConcessionOverview.js';
import './concession.css';
import { USE_DUMMY_CONCESSION_DATA } from './dummyLiveData.js';
import { getConcessionExtension } from './extensions/Slot.js';

const ConcessionLocation = () => {
  return (
    <ConcessionLocationController>
      {(props) => (
        <>
          {props.authCtx.loggedIn ? (
            <>
              {props.loading ? (
                <div className="cx-loading">
                  <Spinner size="large" />
                </div>
              ) : (
                <div className="cx-page">
                  {/* TEMPORARY: remove with dummyLiveData.js */}
                  {USE_DUMMY_CONCESSION_DATA && (
                    <div style={{ background: '#d97706', color: '#fff', textAlign: 'center', padding: '4px', fontWeight: 600 }}>
                      Dummy data mode: schedule and section data are fake (local dev only)
                    </div>
                  )}
                  <div className="sticky-top cx-topbar">
                    <div>
                      <ConcessionHeaderNav
                        currentLocation={props.currentLocation}
                        isToday={props.isToday}
                        selectedDate={props.selectedDate}
                        setDayType={props.setDayType}
                        dayType={props.dayType}
                      />
                      {props.dayType === "game" && (
                        <GameSelector
                        loading={props.loading}
                        currentLocation={props.currentLocation}
                        currentSeries={props.currentSeries}
                        currentGame={props.currentGame}
                        currentSeason={props.currentSeason}
                        setCurrentSeason={props.setCurrentSeason}
                        games={props.games}
                        now={props.now}
                        isToday={props.isToday}
                        setCurrentGame={props.setCurrentGame}
                        setCurrentSeries={props.setCurrentSeries}
                        setSelectedDate={props.setSelectedDate}
                        theme={props.theme}
                      />
                      )}
                    </div>
                  </div>

                  <div className="cx-content">
                    {props.isToday && props.dayType === 'game' ? (
                        <ConcessionLocationLiveView {...props} extension={getConcessionExtension(props.authCtx, props.currentLocation)} />
                    ) : !props.isToday && props.dayType === 'game' ? (
                        <ConcessionLocationHistoricalView 
                        {...props} 
                        extension={getConcessionExtension(props.authCtx, props.currentLocation)}
                        // Pass the calculation functions needed for filtering
                        calculateStats={props.calculateStats}
                        calculateCountStats={props.calculateCountStats}
                        />
                    ) : props.dayType === 'overview' ? (
                        <ConcessionOverview {...props} />
                    ) : null}
                    </div>
                </div>
              )}
            </>
          ) : (
            <div className="cx-unauthorized">
              <Link to={"/auth"}>
                Not Authorized. Please Log-In with given credentials or contact support.
              </Link>
            </div>
          )}
        </>
      )}
    </ConcessionLocationController>
  );
};

export default ConcessionLocation;